/* global dataLayer */
import { activityLoggerService } from './ActivityLoggerService';
import $ from 'jquery';

function findSelectedDownload(node, tag) {
    while (node) {
        let dataItemAttribute = node.getAttribute('data-item');
        if (dataItemAttribute && dataItemAttribute !== '') {
            return dataItemAttribute;
        } else {
            node = node.parentNode;
            if (node.tagName.toLowerCase() === 'tr') {
                dataItemAttribute = node.getAttribute('data-item');
                if (dataItemAttribute && dataItemAttribute !== '') {
                    return dataItemAttribute;
                }
            }
        }
    }
    return undefined;
}

export default {
    init() {
        // Bind download buttons
        $(document).on('click', '.download-link', function () {
            let download = findSelectedDownload(this);

            if (download && download !== '') {
                activityLoggerService.logConfiguratorActivity({ 'ActivityCodeName': 'DownloadOverview.DownloadRequest', 'ActivityTitle': `Requested download for '${download}'`, 'ActivityValue': download });

                // Log Google Analytics
                dataLayer.push({
                    'event': 'DownloadRequested',
                    'detail': {
                        'ActivityCodeName': 'DownloadRequested',
                        'ActivityTitle': `Requested download for '${download}'`,
                        'ActivityValue': download
                    }
                });
            }
        });
    }
};



// WEBPACK FOOTER //
// ./CMS/scripts/modules/DownloadActivityLogger.js